import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateOrderProcessInput,
    OrderProcess,
    UpdateOrderProcessInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PopOrderProcessService {
    private amplifyClient = generateClient();

    constructor() {}

    async listPopOrderProcesses(): Promise<OrderProcess[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listOrderProcesses
                })
            ).data.listOrderProcesses.items;
            if (data) return data as OrderProcess[];
        } catch (error) {
            console.error('Error finding PopOrderProcess:', error);
            return null;
        }
    }

    async listAllPopOrderProcesses(
        pageLimit: number = 100
    ): Promise<OrderProcess[]> {
        const processes: OrderProcess[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listOrderProcesses,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listOrderProcesses;
                processes.push(...((response?.items ?? []) as OrderProcess[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return processes;
        } catch (error) {
            console.error('Error finding PopOrderProcess:', error);
            return [];
        }
    }

    async popProcessByClient(clientId: string): Promise<OrderProcess[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.OrderProcessByClient,
                    variables: {
                        clientId
                    }
                })
            ).data.OrderProcessByClient.items;
            if (data) return data as OrderProcess[];
        } catch (error) {
            console.error('Error finding PopOrderProcess:', error);
            return null;
        }
    }

    async createPopOrderProcess(
        input: CreateOrderProcessInput
    ): Promise<OrderProcess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderProcess,
                    variables: {
                        input
                    }
                })
            ).data.createOrderProcess;
            if (data) return data as OrderProcess;
        } catch (error) {
            console.error('Error creating PopOrderProcess:', error);
            return null;
        }
    }

    async updatePopOrderProcess(
        input: UpdateOrderProcessInput
    ): Promise<OrderProcess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderProcess,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderProcess;
            if (data) return data as OrderProcess;
        } catch (error) {
            console.error('Error updating PopOrderProcess:', error);
            return null;
        }
    }
}
